import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "px-4 py-3.5 bg-blue-50 border-t border-b border-blue-200" };
const _hoisted_2 = { class: "flex flex-wrap items-end gap-2.5" };
const _hoisted_3 = { class: "flex flex-col gap-1 w-52" };
const _hoisted_4 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "flex flex-col gap-1 w-36" };
const _hoisted_7 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_8 = { value: "FLAT" };
const _hoisted_9 = { value: "PERCENTAGE" };
const _hoisted_10 = { class: "flex flex-col gap-1 w-28" };
const _hoisted_11 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_12 = { class: "relative" };
const _hoisted_13 = { class: "absolute left-2.5 top-1/2 -translate-y-1/2 text-sm text-gray-400" };
const _hoisted_14 = ["max"];
const _hoisted_15 = { class: "flex flex-col gap-1 w-40" };
const _hoisted_16 = { class: "text-xs font-medium text-gray-600" };
const _hoisted_17 = { value: "LINE_ITEM" };
const _hoisted_18 = { value: "GROUPED" };
const _hoisted_19 = { class: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3" };
const _hoisted_20 = { class: "sr-only" };
const _hoisted_21 = { class: "flex items-start gap-2 text-xs text-gray-700" };
const _hoisted_22 = { class: "flex flex-col gap-0.5" };
const _hoisted_23 = { class: "font-medium" };
const _hoisted_24 = { class: "text-gray-500" };
const _hoisted_25 = { class: "flex items-start gap-2 text-xs text-gray-700" };
const _hoisted_26 = { class: "flex flex-col gap-0.5" };
const _hoisted_27 = { class: "font-medium" };
const _hoisted_28 = { class: "text-gray-500" };
const _hoisted_29 = { class: "text-xs text-amber-700" };
const _hoisted_30 = {
    key: 0,
    class: "flex flex-col gap-0.5"
};
const _hoisted_31 = {
    key: 0,
    class: "text-xs text-red-500"
};
const _hoisted_32 = {
    key: 1,
    class: "text-xs text-red-500"
};
const _hoisted_33 = { class: "flex items-center justify-end gap-3" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = {
    key: 0,
    class: "w-3.5 h-3.5 animate-spin",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
};
const _hoisted_36 = {
    key: 1,
    class: "w-3.5 h-3.5",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2.5",
    stroke: "currentColor"
};
import { reactive, computed, watch } from "vue";
import { translateApp } from "@/i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChargeEditorRow',
    props: {
        template: {},
        isSaving: { type: Boolean }
    },
    emits: ["save", "cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const form = reactive({
            name: "",
            type: "FLAT",
            amount: 0,
            display_mode: "LINE_ITEM",
            is_mandatory: true,
            compounds_percentage: false,
        });
        const touched = reactive({});
        watch(() => props.template, (t) => {
            if (t) {
                form.name = t.name;
                form.type = t.type;
                form.amount = t.amount;
                form.display_mode = t.display_mode;
                form.is_mandatory = t.is_mandatory;
                form.compounds_percentage = t.compounds_percentage;
            }
            else {
                form.name = "";
                form.type = "FLAT";
                form.amount = 0;
                form.display_mode = "LINE_ITEM";
                form.is_mandatory = true;
                form.compounds_percentage = false;
            }
            Object.keys(touched).forEach((k) => delete touched[k]);
        }, { immediate: true });
        const errors = computed(() => {
            const e = {};
            if (touched.name) {
                if (!form.name.trim())
                    e.name = translateApp("services.charges.validation.name_required");
                else if (form.name.trim().length < 2)
                    e.name = translateApp("services.charges.validation.name_min");
                else if (form.name.trim().length > 60)
                    e.name = translateApp("services.charges.validation.name_max");
            }
            if (touched.amount) {
                if (form.amount < 0)
                    e.amount = translateApp("services.charges.validation.amount_non_negative");
                if (form.type === "PERCENTAGE" && form.amount > 100)
                    e.amount = translateApp("services.charges.validation.percentage_max");
            }
            return e;
        });
        const hasErrors = computed(() => Object.keys(errors.value).length > 0);
        function touch(field) {
            touched[field] = true;
        }
        function handleSave() {
            touched.name = true;
            touched.amount = true;
            if (hasErrors.value)
                return;
            if (!form.name.trim())
                return;
            emit("save", {
                name: form.name.trim(),
                type: form.type,
                amount: form.amount,
                display_mode: form.display_mode,
                is_mandatory: form.is_mandatory,
                compounds_percentage: form.compounds_percentage,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSave, ["prevent"]),
                    class: "flex flex-col gap-3"
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("label", _hoisted_4, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.name")) + " ", 1),
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                            ]),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.name) = $event)),
                                type: "text",
                                maxlength: "60",
                                placeholder: _ctx.$t('services.charges.placeholders.global_name'),
                                class: _normalizeClass(["h-8 px-2.5 text-sm bg-white border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400", errors.value.name ? 'border-red-400' : 'border-gray-300']),
                                onBlur: _cache[1] || (_cache[1] = ($event) => (touch('name')))
                            }, null, 42, _hoisted_5), [
                                [_vModelText, form.name]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("label", _hoisted_7, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.type")) + " ", 1),
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                            ]),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.type) = $event)),
                                class: "h-8 px-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                            }, [
                                _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("services.charges.types.flat")), 1),
                                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t("services.charges.types.percentage")), 1)
                            ], 512), [
                                [_vModelSelect, form.type]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("label", _hoisted_11, [
                                _createTextVNode(_toDisplayString(_ctx.$t("services.charges.labels.amount")) + " ", 1),
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(form.type === "PERCENTAGE" ? "%" : "$"), 1),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.amount) = $event)),
                                    type: "number",
                                    min: "0",
                                    max: form.type === 'PERCENTAGE' ? 100 : undefined,
                                    step: "0.01",
                                    class: _normalizeClass(["w-full h-8 pl-6 pr-2 text-sm bg-white border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400", errors.value.amount ? 'border-red-400' : 'border-gray-300']),
                                    onBlur: _cache[4] || (_cache[4] = ($event) => (touch('amount')))
                                }, null, 42, _hoisted_14), [
                                    [
                                        _vModelText,
                                        form.amount,
                                        void 0,
                                        { number: true }
                                    ]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("services.charges.labels.customer_display")), 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.display_mode) = $event)),
                                class: "h-8 px-2 text-sm bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                            }, [
                                _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t("services.charges.display.line_item")), 1),
                                _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t("services.charges.display.grouped")), 1)
                            ], 512), [
                                [_vModelSelect, form.display_mode]
                            ])
                        ])
                    ]),
                    _createElementVNode("fieldset", _hoisted_19, [
                        _createElementVNode("legend", _hoisted_20, _toDisplayString(_ctx.$t("services.charges.labels.calculation_rules")), 1),
                        _createElementVNode("label", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.is_mandatory) = $event)),
                                "data-test": "charge-mandatory",
                                type: "checkbox",
                                class: "w-4 h-4 mt-0.5 text-egreen border-gray-300 rounded focus:ring-egreen"
                            }, null, 512), [
                                [_vModelCheckbox, form.is_mandatory]
                            ]),
                            _createElementVNode("span", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("services.charges.labels.mandatory")), 1),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("services.charges.labels.mandatory_help")), 1)
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.compounds_percentage) = $event)),
                                "data-test": "charge-compounds",
                                type: "checkbox",
                                class: "w-4 h-4 mt-0.5 text-egreen border-gray-300 rounded focus:ring-egreen"
                            }, null, 512), [
                                [_vModelCheckbox, form.compounds_percentage]
                            ]),
                            _createElementVNode("span", _hoisted_26, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("services.charges.labels.compounds_percentage")), 1),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("services.charges.labels.compounds_percentage_help")), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("services.charges.labels.customer_visible_warning")), 1),
                    (hasErrors.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (errors.value.name)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(errors.value.name), 1))
                                : _createCommentVNode("", true),
                            (errors.value.amount)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(errors.value.amount), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "text-sm text-gray-500 transition-colors hover:text-gray-700",
                            onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.$emit('cancel')))
                        }, _toDisplayString(_ctx.$t("services.charges.actions.cancel")), 1),
                        _createElementVNode("button", {
                            type: "submit",
                            class: "flex items-center gap-1.5 px-3.5 py-1.5 text-sm font-medium text-white bg-egreen-500 rounded-md hover:bg-egreen-600 transition-colors disabled:opacity-50",
                            disabled: __props.isSaving
                        }, [
                            (__props.isSaving)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_35, [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("circle", {
                                            class: "opacity-25",
                                            cx: "12",
                                            cy: "12",
                                            r: "10",
                                            stroke: "currentColor",
                                            "stroke-width": "4"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                            class: "opacity-75",
                                            fill: "currentColor",
                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        }, null, -1)
                                    ]))]))
                                : (_openBlock(), _createElementBlock("svg", _hoisted_36, [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "m4.5 12.75 6 6 9-13.5"
                                        }, null, -1)
                                    ]))])),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.save")), 1)
                        ], 8, _hoisted_34)
                    ])
                ], 32)
            ]));
        };
    }
});
